import { useQuery } from '@tanstack/react-query';
import { queryKey } from '../../../constant/queryKey';
import { retailAdService } from 'shared/src/api';

export const useRetailAd = (adSlotId: number) => {
  return useQuery({
    queryKey: queryKey.retailAd(adSlotId),
    queryFn: () => retailAdService.getRetailAd(adSlotId),
  });
};
